import React, { useEffect, useState } from 'react'
import { Container, Title, TitleGroup, TitleWrapper } from '../../components/listing/AMSListing'
import { useTheme } from '../../middleware/ThemeContext'
import StyledText from '../../components/StyledComponents/StyledText';
import styled from 'styled-components';
import BGImage from '../../assets/images/duplicate-bg.png';
import ImgTextRadio from './ImgTextRadio';
import ContactImg from '../../assets/images/team-1.png';
import OrganizationImg from '../../assets/images/Team-2.png';
import CriteriaCheckbox from './CriteriaCheckbox';
import { Form, Formik } from 'formik';
import { Button } from '../../components/form/Button';
import TwoUsersIcon from '../../assets/icons/TwoUsersIcon';
import ViewIcon from '../../assets/icons/ViewIcon';
import { useGetDuplicateCriteriaQuery, useSaveCriteriaMutation } from '../../api/duplicateApiSlice';
import { SkeletonCell } from '../../components/SkeletonCell';
import { useToast } from '../../components/toast/ToastContext';
import LoadingCircleIcon from '../../assets/icons/LoadingCircleIcon';
import { useNavigate } from 'react-router-dom';
import SingleDocumentIcon from '../../assets/icons/SingleDocumentIcon';


const DuplicateChecker = () => {
    const {theme} = useTheme();
    const showToast = useToast();
    const navigate = useNavigate();
    const [scope , setScope] = useState<string>('contact');

    const {data: criteria, isLoading, error, refetch, isFetching} = useGetDuplicateCriteriaQuery(scope, {
        refetchOnMountOrArgChange: true,
    });
    const [saveCriteria, { isLoading: loadingCriteria, isSuccess, isError, error: err }] = useSaveCriteriaMutation();

    const criteriaColumns = criteria?.duplicateCriteria?.columns;

    const contactScope = [
        {
            value: 'firstName',
            label: 'First Name',
            match: 'Exact Match',
            case: 'Ignore Case Sensitivity'
        },
        {
            value: 'lastName',
            label: 'Last Name',
            match: 'Exact Match',
            case: 'Ignore Case Sensitivity'
        },
        {
            value: 'email',
            label: 'Email Address',
            match: 'Fuzzy Match',
            case: 'Ignore Case Sensitivity'
        }
    ];

    const OrgScope = [
        {
            value: 'name',
            label: 'Organization Name',
            match: 'Fuzzy Match',
            case: 'Ignore Case Sensitivity'
        }
    ];

    const initialValues = React.useMemo(() => ({
        scope: 'contact',
        contact: (scope === 'contact' ? criteriaColumns : []) || [],
        organization: (scope === 'organization' ? criteriaColumns : []) || []
    }), [criteriaColumns, scope]);

    const handleSubmit = async (values: typeof initialValues) => {
        const criteriaPayload = {
            "moduleCriteria": scope,
            "columns": scope == 'contact' ? values.contact : values.organization,
        }
        if(criteriaPayload.columns.length != 0){
            try {
            const result = await saveCriteria(criteriaPayload).unwrap(); 
            showToast('Success', 'Duplicate criteria saved successfully', 'success');
            refetch();
            } catch (err) {
            console.error('Merge failed:', err);
            showToast('Error', 'Failed to update criteria', 'error');
            }
        } else {
            showToast('Error', 'Please select some criteria', 'error');
        }
    };
    
  return (
    <>
        <Container theme={theme} className='rounded-0'>
            <div className="d-flex justify-content-between mt-0">
                <div className="d-flex align-items-center gap-2">
                    <TitleGroup>
                        <TitleWrapper>
                        <Title theme={theme}>Duplicate Checker</Title>
                        </TitleWrapper>
                        <StyledText className='mt-2' fontSize="14px" fontWeight={300} textColor={theme.CorporateTheme.colors.textSecondary}>
                            Run the duplicate finder to find duplicate record accross the system
                        </StyledText>
                    </TitleGroup>
                </div>
            </div>
        </Container>
        <div className="container-fluid" 
        style={{ height: 'calc(100vh - 137px)' }}
        >
            <div style={{
                backgroundColor: theme.CorporateTheme.colors.bannerBg,
                height: 'calc(100vh - 137px)',
                overflow: 'auto',
            }}>
                <div style={{ width: '788px', margin: '0 auto', paddingTop: '60px', paddingBottom: '60px' }}>

                    <DuplicateHeader theme={theme}>
                        <StyledText fontSize='18px' fontWeight={700} lineHeight='25px'>
                            Run Duplicate Checker
                        </StyledText>
                        <StyledText 
                        fontSize='14px' 
                        fontWeight={400} 
                        textColor={theme.CorporateTheme.colors.textSecondary} 
                        style={{ lineHeight: '20px' }}>
                            Choose the criteria you'd like to use for identifying <br/> duplicates. Then, click to run the checker.
                        </StyledText>
                    </DuplicateHeader>
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        onSubmit={handleSubmit}
                    >
                        {(formik) =>{ 
                        const { errors, submitCount } = formik;
                        return (
                        <Form >
                    <ConScope theme={theme}>
                        <div style={{ padding: '30px' }}>
                            <StyledText 
                                fontSize='16px' 
                                fontWeight={600} 
                                textColor={theme.CorporateTheme.colors.headerColor}
                                style={{ marginBottom: '20px' }}
                            >
                                Select duplicate finder scope here
                            </StyledText>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <ImgTextRadio 
                                    name='scope'
                                    value='contact'
                                    title='Contact Duplicates'
                                    text='Select criteria to detect and find duplicate contact records.'
                                    image={ContactImg}
                                    isCheck={scope == 'contact' ? true : false}
                                    onClick={(field_key, value) => formik.setFieldValue(field_key, value)}
                                    SetScope={() => setScope('contact')}
                                    onChange={formik.handleChange}
                                />
                                <ImgTextRadio 
                                    name='scope'
                                    value='organization'
                                    title='Organization Duplicates'
                                    text='Select criteria to detect and find duplicate contact records.'
                                    image={OrganizationImg}
                                    isCheck={scope == 'organization' ? true : false}
                                    onClick={(field_key, value) => formik.setFieldValue(field_key, value)}
                                    SetScope={() => setScope('organization')}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                        <ConCriteria theme={theme}>
                            <StyledText 
                                fontSize='13px' 
                                fontWeight={400} 
                                textColor={theme.CorporateTheme.colors.paraColor}
                                style={{ marginBottom: '20px' }}
                            >
                                Pick your criteria, click 'Run Duplicate Checker' — and boom, duplicates revealed!
                            </StyledText>
                            {isLoading || isFetching ? (
                                <>
                                <SkeletonCell style={{ width: '100%', height: '65px', marginBottom: '5px' }} />
                                <SkeletonCell style={{ width: '100%', height: '65px' }} />
                                </>
                            ) : (
                                <>
                                    {scope == 'contact' &&
                                    contactScope.map((criteria, index) => (
                                        <CriteriaCheckbox 
                                            key={index}
                                            name='contact'
                                            value={criteria.value}
                                            label={criteria.label}
                                            match={criteria.match}
                                            Case={criteria.case}
                                            isCheck={formik.values.contact.includes(criteria.value) ? true : false}
                                            onClick={(field_key, value) => formik.setFieldValue(field_key, value)}
                                            onChange={formik.handleChange}
                                        />
                                    ))}
                                    {scope == 'organization' &&
                                    OrgScope.map((criteria, index) => (
                                        <CriteriaCheckbox 
                                            key={index}
                                            name='organization'
                                            value={criteria.value}
                                            label={criteria.label}
                                            match={criteria.match}
                                            Case={criteria.case}
                                            isCheck={formik.values.organization.includes(criteria.value) ? true : false}
                                            onClick={(field_key, value) => formik.setFieldValue(field_key, value)}
                                            onChange={formik.handleChange}
                                        />
                                    ))}
                                </>
                            )}
                        </ConCriteria>
                        <div className='d-flex justify-content-center gap-2 my-4'>
                            <Button theme={theme} type="submit" $variant="add">
                                {loadingCriteria ?
                                <LoadingCircleIcon color={theme.CorporateTheme.colors.background} />
                                :
                                <SingleDocumentIcon color={theme.CorporateTheme.colors.background} />
                                }
                                Save Criteria
                            </Button>
                            {criteriaColumns?.length != 0 ?
                                <Button theme={theme} type="button" $variant="cancel" 
                                    onClick={() =>
                                        scope == 'contact' ?
                                         navigate('/home/duplicate-checker/contacts') :
                                         navigate('/home/duplicate-checker/organization')
                                        } 
                                >
                                    <ViewIcon color={theme.CorporateTheme.colors.textSecondary} />
                                    View
                                </Button>
                                :
                                null
                            }
                        </div>
                    </ConScope>
                    </Form>
                    )}}
                    </Formik>
                </div>
            </div>
        </div>
    </>
  )
}

const DuplicateHeader = styled.div`
    background-color: ${({theme}) => theme.colors.contentBackground};
    background-image: url(${BGImage});
    text-align: center;
    padding: 61px 0px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid;
    border-image-source: linear-gradient(180deg, #C9DFFF 43.78%, #FFFFFF 100%);
    border-radius: 5px;
`;
const ConScope = styled.div`
    background-color: ${({theme}) => theme.colors.contentBackground};
    border: 1px solid ${({theme}) => theme.CorporateTheme.colors.border};
    border-radius: 5px;
    padding: 12px;
    margin-top: 10px;
`;
const ConCriteria = styled.div`
    background-color: ${({theme}) => theme.CorporateTheme.colors.bannerBg};
    padding: 20px;
`;

export default DuplicateChecker